import { Component } from '@theme/component';

/** Vex caches Italian product labels; Shopify remains the translation source. */
class BioClockGiftLocalization extends Component {
  #products = {};
  #observer;
  #controller;
  #frame;

  connectedCallback() {
    super.connectedCallback();
    this.#cleanUp();
    try {
      this.#products = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '{}');
    } catch {
      return;
    }
    this.#controller = new AbortController();
    document.addEventListener('change', this.#changed, { signal: this.#controller.signal });
    this.#observer = new MutationObserver((records) => {
      if (records.some((record) => {
        const element = record.target instanceof Element ? record.target : record.target.parentElement;
        return element?.closest('#v-popup') || [...record.addedNodes].some((node) =>
          node instanceof Element && (node.matches('#v-popup, #v-popup-overlay') || node.querySelector('#v-popup'))
        );
      })) this.#schedule();
    });
    this.#observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['src'] });
    this.#schedule();
  }

  disconnectedCallback() {
    this.#cleanUp();
    super.disconnectedCallback();
  }

  #cleanUp() {
    this.#controller?.abort();
    this.#observer?.disconnect();
    if (this.#frame) cancelAnimationFrame(this.#frame);
    this.#frame = null;
  }

  #changed = (event) => {
    if (event.target instanceof HTMLSelectElement && event.target.id === 'v-product-select') this.#schedule();
  };

  #schedule = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = null;
      const popup = document.getElementById('v-popup');
      const select = popup?.querySelector('#v-product-select');
      if (!(select instanceof HTMLSelectElement)) return;
      for (const option of select.options) {
        const product = this.#products[option.value];
        if (product && option.textContent !== product.title) option.textContent = product.title;
      }
      const product = this.#products[select.value];
      if (!product) return;
      const name = popup.querySelector('#v-product-name');
      if (name && name.textContent !== product.title) name.textContent = product.title;
      const image = popup.querySelector('#v-product-image');
      if (image instanceof HTMLImageElement) {
        if (image.alt !== product.alt) image.alt = product.alt;
        if (product.image && image.getAttribute('src') !== product.image) image.setAttribute('src', product.image);
      }
      const label = popup.querySelector('#v-popup-title')?.textContent;
      if (label && select.getAttribute('aria-label') !== label) select.setAttribute('aria-label', label);
    });
  };
}

if (!customElements.get('bc-gift-localization')) customElements.define('bc-gift-localization', BioClockGiftLocalization);
